import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Label from '../../EntToEndUI/Label/Label';
import styles from './RequestForm.module.css';
import { useScroll } from '../../../context/ScrollContext';

const RequestForm = () => {
  const { t } = useTranslation();
  const [formData, setState] = useState({
    name: '',
    phone: '',
    message: '',
    agreement: false
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitResult, setSubmitResult] = useState(null);
  const [isHighlighted, setIsHighlighted] = useState(false);

  // Получаем ссылку и состояние подсвеченной секции из контекста
  const { refs, highlightedSection, isScrolling } = useScroll();

  // Эффект для обработки подсветки формы
  useEffect(() => {
    // Подсвечиваем только если скролл завершен и секция выбрана
    if (!isScrolling && highlightedSection === 'requestForm') {
      console.log('Форма подсвечена после завершения скролла');
      setIsHighlighted(true);
    } else {
      setIsHighlighted(false);
    }
  }, [highlightedSection, isScrolling]);

  // Обработка изменений в полях формы
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setState({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
    
    console.log(`Изменено поле ${name}: ${type === 'checkbox' ? checked : value}`);
  };

  // Отправка формы
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Валидация формы
    if (!formData.name || !formData.phone || !formData.agreement) {
      console.error('Не все обязательные поля заполнены');
      setSubmitResult({
        success: false,
        message: 'Пожалуйста, заполните все обязательные поля и примите соглашение'
      });
      return;
    }

    setIsSubmitting(true);
    console.log('Отправка данных формы:', formData);

    try {
      // Здесь будет логика отправки данных на сервер
      // const response = await fetch(process.env.REACT_APP_API_URL, {...});
      
      // Имитация успешной отправки
      setTimeout(() => {
        setIsSubmitting(false);
        setSubmitResult({
          success: true,
          message: 'Ваша заявка успешно отправлена!'
        });
        console.log('Форма успешно отправлена');

        // Сброс формы после успешной отправки
        setState({
          name: '',
          phone: '',
          message: '',
          agreement: false
        });
      }, 1000);
    } catch (error) {
      console.error('Ошибка при отправке формы:', error);
      setIsSubmitting(false);
      setSubmitResult({
        success: false,
        message: 'Произошла ошибка при отправке формы. Пожалуйста, попробуйте позже.'
      });
    }
  };

  return (
    <section className={styles.requestFormSection}>
      <div 
        className={styles.requestFormContainer} 
        ref={refs.requestForm}
      >
        <div className={styles.requestFormSteps}>
          <Label 
            topText={t('requestForm.title')}
            bottomText={t('requestForm.subTitle')}
            shift="small"
            className={styles.mt0}
          />
          
          <ol className={styles.requestStepsList}>
            <li>{t('requestForm.step1')}</li>
            <li>{t('requestForm.step2')}</li>
            <li>{t('requestForm.step3')}</li>
            <li>{t('requestForm.step4')}</li>
            <li>{t('requestForm.step5')}</li>
          </ol>
        </div>
        
        <div className={`${styles.requestFormWrapper} ${isHighlighted ? styles.highlighted : ''}`}>
          <div className={styles.formHeader}>
            <h3>Заполните форму, и мы найдем решение для Вашей задачи!</h3>
          </div>
          
          <form onSubmit={handleSubmit} className={styles.requestForm}>
            <div className={styles.formGroup}>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Ваше имя"
                required
              />
            </div>
            
            <div className={styles.formGroup}>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="+7 (999) 888-77-66"
                required
              />
            </div>
            
            <div className={styles.formGroup}>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Ваше обращение"
                rows="4"
              ></textarea>
            </div>
            
            <div className={`${styles.formGroup} ${styles.checkboxGroup}`}>
              <label>
                <input
                  type="checkbox"
                  name="agreement"
                  checked={formData.agreement}
                  onChange={handleChange}
                  required
                />
                <span>Я даю согласие на обработку персональных данных</span>
              </label>
            </div>
            
            <div className={styles.formGroup}>
              <button type="submit" disabled={isSubmitting}>
                {isSubmitting ? 'Отправка...' : 'Отправить'}
              </button>
            </div>
            
            {submitResult && (
              <div className={`${styles.submitResult} ${submitResult.success ? styles.success : styles.error}`}>
                {submitResult.message}
              </div>
            )}
          </form>
        </div>
      </div>
    </section>
  );
};

export default RequestForm; 